export default "/703b50bec2b920e04be830253384aba7.jpg";